import { apiClient } from "./httpClient";
import { unwrapEnvelope, unwrapList, unwrapMeta } from "./response";

export const petsApi = {
  async list(params = {}) {
    const response = await apiClient.get("/pets", { params });
    return {
      data: unwrapList(response.data),
      meta: unwrapMeta(response.data)
    };
  },

  async get(id) {
    const response = await apiClient.get(`/pets/${id}`);
    return unwrapEnvelope(response.data, null);
  },

  async create(payload) {
    const response = await apiClient.post("/pets", payload);
    return unwrapEnvelope(response.data, null);
  },

  async update(id, payload) {
    const response = await apiClient.put(`/pets/${id}`, payload);
    return unwrapEnvelope(response.data, null);
  },

  async remove(id) {
    const response = await apiClient.delete(`/pets/${id}`);
    return unwrapEnvelope(response.data, null);
  },

  async count(params = {}) {
    const response = await apiClient.get("/pets/count", { params });
    return unwrapEnvelope(response.data, { count: 0 });
  }
};
